<template>
    <div>
        <div class="OOP-today OOP-today__oop">
            <div class="player-filter__type player-filter__type--full">
                <label class="vh" for="courtSelector">
                    Select Court
                </label>
                <select ref="courtSelector" id="courtSelector" name="courtSelector" v-model="selectedCourt">
                    <option v-for="(court, courtIndex) in courts" :value="court.id">{{court.name}}</option>
                </select>
            </div>

            <flickity ref="flickity" :options="flickityOptions" class="OOP-today__flickity" v-if="Object.keys(matches).length > 0">

                <div class="Match__OOP__carousel" v-for="match in matches">

                    <score-card
                        v-if      =" match.detail && match.detail.cA"
                        :match    = "match"
                        :flagPath = "flagPath"
                        :key      = "match.id"
                        :detail   = "detail"
                        type     = "all"
                        mode      = "live"
                        :data-id  = "match.id">
                    </score-card>

                    <oop-match
                            v-if="!match.detail || !match.detail.cA"
                            type="all"
                            :flagPath="flagPath"
                            :ticket="ticket"
                            :key="match.id"
                            :detail="detail"
                            :match="match"
                            :court="selectedCourt">
                    </oop-match>

                </div>

            </flickity>

        </div>

        <a class="general-button blue-background generic-medium" :href="ooplink">View Full Order of Play</a>
    </div>
</template>

<script>
    import axios from 'axios'
    import moment from 'moment'
    import MatchCard from './MatchCard'
    import Flickity from './Flickity';
    import 'select2/dist/js/select2.full.js'
    import tz from 'moment-timezone'
    import OOPMatch from './OOPMatch'

    export default {
        props: ['ticket', 'flag', 'detail', 'ooplink'],
        components: {
            'score-card': MatchCard,
            'oop-match': OOPMatch,
            Flickity
        },
        data() {
            return {
                flagPath      : this.flag + '/assets/dist/svg/flags/',
                oop           : [],
                today         : '',
                wtaFeed       : [],
                wtaMatches    : [],
                feedDraws     : [],
                selectedCourt : '',
                matches       : [],
                courts        : [],
                type          : [ 'all' ],
                carousel      : null,
                flickityOptions : {
                    cellSelector    : '.Match__OOP__carousel',
                    prevNextButtons : true,
                    pageDots        : true,
                    groupCells      : true,

                },
            }
        },
        mounted() {
            let app = this

            jQuery('#courtSelector').select2({
                width: '100%'
            }).on('change', function () {
                app.selectedCourt = this.value
            })
        },
        watch: {
            selectedCourt(newValue, oldValue) {

                this.carousel = jQuery('.OOP-today__oop .OOP-today__flickity').flickity()
                this.carousel.flickity('destroy')

                this.matches = this.getMatchesByCourt(newValue)

                let app = this

                setTimeout( function() {
                    app.carousel.flickity(app.flickityOptions)
                }, 50 )
            }
        },
        created() {
            this.getDraws()
            this.getFeed().then( () => {
                this.initCarousel()
            })
        },
        methods: {
            getFeed() {
                return axios.get(`${window.feed_ip}/get/${window.tournament}/oop-mixed`).then(response => {

                    let oop = response.data

                    // switch to last day from feed after 8pm
                    let todayDate = moment().tz('America/New_York').startOf('day').format('YYYY-MM-DD')
                    let nowTime   = moment().tz('America/New_York').format('HH')
                    let usedDay   = ''

                    if ( nowTime >= 20 )
                        usedDay = response.data[response.data.length - 1].date
                    else
                        usedDay = todayDate

                    let today = oop.filter(function (day) {
                        return day.date == usedDay
                        // return day.date
                    })

                    this.oop = response.data

                    if( !today[0] )
                        return;

                    today = today[0]

                    if (today.length == '0') {

                        let totalDaysCount = response.data.length
                        this.today = response.data[totalDaysCount - 1]

                        for ( let i = 0; i < response.data[totalDaysCount - 1].courts.length; i++ ) {
                            if ( response.data[totalDaysCount - 1].courts[i].matches.length >= 1 ) {
                                this.selectedCourt = response.data[totalDaysCount - 1].courts[i].id
                                break;
                            }
                        }

                    } else {
                        this.today = today

                        for ( let i = 0; i < today.courts.length; i++ ) {
                            if ( today.courts[i].matches.length >= 1 ) {
                                this.selectedCourt = today.courts[i].id
                                break;
                            }
                        }
                    }
                    this.matches = this.getMatchesByCourt(this.selectedCourt)

                    this.setupCourts()

                }).catch(function (error) {
                    console.log(error);
                });

            },
            getDraws() {

                let url = `${window.feed_ip}/get/wta/${window.tournament}/draws`

                axios.get( url ).then(response => {

                    this.feedDraws = response.data
                    let feedDraws = response.data
                    this.setupEvents(feedDraws)


                }).catch(function (error) {
                    console.log(error)
                })

            },
            setupEvents(feed) {
                let events = []

                for (let event of feed)
                    events.push(event.description)

                this.events        = events
                this.selectedEvent = events[0]

                if (this.assoc == 'wta') {

                    if(this.feed[1] && this.feed[1].code == "LS"){
                        const temp = events[0];
                        events[0] = events[1];
                        events[1] = temp;
                    }
                    this.selectedEvent = events[0]

                }

                if((typeof window.atp_results_default !== 'undefined') && window.atp_results_default !== "default" && this.assoc == 'atp'){
                    this.selectedEvent = events[Number(window.atp_results_default)]
                }

                if((typeof window.wta_results_default !== 'undefined') && window.wta_results_default !== "default" && this.assoc == 'wta'){
                    this.selectedEvent = events[Number(window.wta_results_default)]
                }

                let vm = this

                jQuery('#s2eventSelector').empty().select2({
                    width: '100%',
                    data: events.map(function (event) {
                        return {
                            id: event,
                            text: event == 'Women\'s Singles Quali' ? 'Women\'s Singles Qualifying' : event
                        }
                    })
                }).val(this.selectedEvent).trigger('change')
            },
            setupCourts() {

                let courts = []
                let today = this.today

                today.courts.forEach( function( court, j ) {
                    if ( court.matches.length > 0 )
                        courts.push( { 'name': court.name.toLowerCase(), 'id': court.id } )
                })

                if ( courts.length < 1 ) {
                    let totalDaysCount = this.oop.length

                    for ( let i = 0; i < this.oop[totalDaysCount - 1].courts.length; i++ ) {
                        if ( this.oop[totalDaysCount - 1].courts[i].matches.length >= 1 ) {
                            courts.push( this.oop[totalDaysCount - 1].courts[i].name )
                            break;
                        }
                    }
                }

                this.courts = courts

            },
            getAllMatchesInOneArray(days) {
                let allMatches = []

                for (let day of days) {
                    for (let court of day.courts) {
                        allMatches.push(...court.matches)
                    }
                }

                return allMatches
            },
            getMatchesByCourt(id) {
                let foundCourt = this.today.courts.filter(function (court) {
                    return court.id == id
                })

                return foundCourt[0].matches
            },
            filterMatchesByType(day, type) {

                day.courts.forEach( function ( court, j ) {
                    day.courts[j].matches = court.matches.filter( function( match ) {
                        if ( match.type == type )
                            return true

                    })
                })

                return day
            },
            initCarousel() {

                // carousel = jQuery('.OOP-today__oop .OOP-today__flickity').flickity()
                    // carousel.flickity('destroy')

                // jQuery('.OOP-today__oop .OOP-today__flickity').flickity( [ this.flickityOptions ] )
            }
        }
    }
</script>
